import API from '../lib/api';

export const getPurchaseHistory = (params) =>
  API.get(`/orders/`).then((response) => response);

export const getTransactions = (params) =>
  API.get(`/order-transactions/`).then((response) => response);

export const getSellerOrders = (params) =>
  API.get(`/seller-orders/`).then((response) => response);